import hoverintent from "hoverintent";

let container;

const settings = {
    container: ".nav-bar",
    slctrParentNavItem: ".has-sub-menu",
    clsIntent: "has-intent",
};

const addHoverIntent = (el) => {
    hoverintent(
        el,
        () => el.classList.add(settings.clsIntent),
        () => el.classList.remove(settings.clsIntent),
    ).options({
        interval: 60,
        timeout: 60,
    });
};

const setSubMenuEvents = () => {
    const items = container.querySelectorAll(settings.slctrParentNavItem);
    Array.prototype.forEach.call(items, (el) => {
        addHoverIntent(el);
    });
};

const NavBar = () => {
    container = document.querySelector(settings.container);
    if (container === null) {
        return;
    }

    setSubMenuEvents();
};

export default NavBar;
